// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upsell-icon{color:#ffa101}.upsell-icon.color-white{color:#fff}.upsell-icon.xs{font-size:12px}.upsell-icon.sm{font-size:16px}.upsell-icon.md{font-size:18px}.upsell-icon.lg{font-size:20px}.upsell-icon.xl{font-size:24px}.locked-badge{border-radius:50%;padding:1.5px;background-color:#ffa101;color:#fff;z-index:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
